
import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { HistoricalNodeData } from '@/hooks/useHistoricalNodesData';

interface NodesChartProps {
  data: HistoricalNodeData[];
  isLoading: boolean;
  error?: unknown;
}

export function NodesChart({ data, isLoading, error }: NodesChartProps) {
  const formatYAxis = (value: number) => {
    return Math.round(value).toString();
  };

  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center text-muted-foreground">
        Loading data...
      </div>
    );
  }

  if (error || !data || data.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-muted-foreground">
        {error ? "Error loading data" : "No historical data available"}
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart 
        data={data} 
        margin={{ top: 5, right: 10, left: 10, bottom: 5 }}
      >
        <XAxis
          dataKey="displayDate"
          stroke="#888888"
          fontSize={10}
          tickLine={false}
          axisLine={false}
          interval="preserveStartEnd"
          tickMargin={5}
        />
        <YAxis
          stroke="#888888"
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={formatYAxis}
          width={45}
          tickCount={5}
          domain={['auto', 'auto']} 
        />
        <Tooltip
          content={({ active, payload }) => {
            if (active && payload && payload.length) {
              const data = payload[0].payload;
              return (
                <div className="rounded-lg border bg-background p-2 shadow-sm">
                  <div className="grid grid-cols-2 gap-2">
                    <div className="flex flex-col">
                      <span className="text-[0.70rem] uppercase text-muted-foreground">
                        Date
                      </span>
                      <span className="font-bold text-sm">
                        {data.displayDate}
                      </span>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-[0.70rem] uppercase text-muted-foreground">
                        Active Nodes
                      </span>
                      <span className="font-bold text-sm">
                        {Math.round(Number(payload[0].value)).toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          }}
        />
        <Line
          type="monotone"
          dataKey="value"
          stroke="#6e46ae"
          strokeWidth={2}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
